import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataTypeReportData } from 'store/ducks/Reportings/types';
import { columns } from 'components/Columns/ReportDataColumns';

interface reportDataProps {
  entityName: string;
}

const ReportData: React.FC<reportDataProps> = ({ entityName }) => {
  const { date, is_additional_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeReportData[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchReportData(params);
      if (fetchedData && Array.isArray(fetchedData.filtered_data)) {
        const date = fetchedData.date;
        const entityName = fetchedData.entity_name;
        const formattedData = fetchedData.filtered_data.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: entityName,
            start_date: dataItem.start_date,
            sensitiveness_of_data_stored_by_ict_tpsp:
              dataItem.sensitiveness_of_data_stored_by_ict_tpsp,
            sensitiveness: dataItem.sensitiveness,
            location_of_data_management: dataItem.location_of_data_management,
            location_of_data_at_rest: dataItem.location_of_data_at_rest,
            id: dataItem.id,
            ict_system_name: dataItem.ict_system_name,
            end_date: dataItem.end_date,
            description: dataItem.description,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_additional_displayed, entityName]);

  return (
    <>
      <Table columns={columns} dataSource={data} scroll={{ x: 1000, y: 430 }} />
    </>
  );
};

export default ReportData;
